import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
export type CertificatesDTO = {
    id: string;
    name: string;
    description: string;
    img_url: string;
    certificateCategory: {
        id: string;
        name: string;
        description: string;
        createdAt: string;
        updatedAt: string;
        certificateExamId: string;
    }[];
};
    type getCertificatesResponse = {
        statusCode?: number;
        error?: null | ApiError;
        data?: CertificatesDTO;
      
    }
    export const GetCertificateById = async (certificateId: string): Promise<getCertificatesResponse> => {
        try {
            const response = await axios.get(`/certificate-exam/${certificateId}`);
                    return { data: response.data.data };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            console.error("API Error:", error);
            if (error.response) {
                const apiError: ApiError = {
                    statusCode: error.response.status,
                    message: error.response.data.message,
                    error: error.response.data.error,
                };
                return { error: apiError };
            } else {
                const fallbackError: ApiError = {
                    statusCode: 500,
                    message: "An unexpected error occurred",
                };
                return { error: fallbackError };
            }
        }
    };
